import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const VideoDark = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#475467"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M10.768 6.449c1.225-.971 2.87-1.911 3.18-1.575.515.553.47 5.81 0 6.312-.285.31-1.942-.63-3.18-1.594" />
        <path
          d="M1.676 8.025c0-3.461 1.15-4.615 4.6-4.615s4.6 1.154 4.6 4.615-1.15 4.616-4.6 4.616-4.6-1.155-4.6-4.616"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};
export default VideoDark;
